import { AbilityBuilder, subject } from "@casl/ability";
const { can, rules } = new AbilityBuilder();
import { Subjects, Actions } from "@/AppAbility";
import Vue from "vue";
import Storage from "@/services/storage";
import { StorageConstants } from "@/enums/storage.enum";

/**
 * @name: create ability
 * @return: {rule}: any
 * @description: function to create new ability rule
 * @example abilityFor(action: Actions, model: Subjects, condition: any, filed?: Array<string>)
 */

export const abilityFor = (action: Actions, model: Subjects, condition: any, filed?: Array<string>): any => {
  can(action, model, filed, condition);
  return rules;
};

/**
 * @name: setup user abilities
 * @return: {void}
 * @description: function to setup user permissions on the app level
 * @example setupUserAbilities();
 * <Can i="read|write|update|delete|..." on="modelName"></Can>
 * Vue.prototype.$ability.can("read|write|update|delete", "modelName")
 */
export const setupUserAbilities = (): void => {
  const permissions: any = Storage.get(StorageConstants.PERMISSION);
  if (!permissions) return;
  const user: any = Storage.get(StorageConstants.SESSION);
  const keys: Array<string> = Object.keys(permissions);

  for (let i = 0; i < keys.length; i++) {
    const action: Actions = permissions[keys[i]];
    const model: Subjects = keys[i];
    const condition: any = user;

    Vue.prototype.$ability.update(abilityFor(action, model, condition));
  }
};

/**
 * @name: get abilities by conditions
 * @return: {conditions, action, subject, inverted, fields}: any | null
 * @description: function to get the rule depend on the condition
 * @example roleForCondition();
 * <Can i="read|write|update|delete" on="modelName"></Can>
 * Vue.prototype.$ability.roleForCondition("modelName", {condition: true|false})
 */
export const roleForCondition = (modelName: string, condition: any, action: string): any => {
  const Model: Subjects = subject.bind(null, modelName);
  return Vue.prototype.$ability.relevantRuleFor(action, Model(condition));
};
